import cx from 'classnames';
import { ReactNode } from 'react';

import { AccordionDetails, AccordionSummary, Accordion as MuiAccordion } from '@material-ui/core';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';

import styles from './Accordion.module.scss';

type AccordionProps = {
  title: string | ReactNode;
  children: React.ReactNode;
  variant?: 'primary' | 'secondary';
  testId?: string;
  top?: boolean;
  bottom?: boolean;
};

export const Accordion = ({
  title,
  children,
  variant = 'primary',
  testId,
  top,
  bottom,
}: AccordionProps) => (
  <div className={styles.accordion}>
    <MuiAccordion data-testid={testId}>
      <AccordionSummary
        expandIcon={<ExpandMoreIcon className={cx(styles.icon, styles[variant])} />}
        className={cx(
          styles.accordionSummary,
          styles[variant],
          top && styles.accordion_top,
          bottom && styles.accordion_bottom,
        )}
      >
        <div className={styles.accordionTitle}>{title}</div>
      </AccordionSummary>
      <AccordionDetails className={styles.accordionDetails}>{children}</AccordionDetails>
    </MuiAccordion>
  </div>
);
